// extracted by mini-css-extract-plugin
export var content = "_d8-3";
export var list = "_d8-4";
export var settingsContent = "_d8-7";
export var settingsPanel = "_d8-8";
export var state = "_d8-6";
export var triggerBadge = "_d8-2";
export var triggerButton = "_d8-1";
export var triggerShell = "_d8-0";
export var unreadDot = "_d8-5";